import type { LinkProps } from "@chakra-ui/react";
import { Link } from "@chakra-ui/react";
import React from "react";
import { analytics } from "@/analytics/ga";
import { observer } from "mobx-react";
import { useStore } from "@/store";
import { translations } from "@/constants/translations";

interface MailToLinkProps extends LinkProps {
  subject?: string;
  body?: string;
}

export const MailToLink = observer(
  ({
    href = "customerservicecanada@ebsi.com",
    subject,
    body,
    ...props
  }: MailToLinkProps) => {
    const { activeLanguage } = useStore();
    const language = translations.common["email"][activeLanguage];

    subject = subject || language.subject;

    let hrefStr = `mailto:${href}?subject=${subject}`;

    if (body) hrefStr = `${hrefStr}&body=${body}`;

    return (
      <Link
        onClick={() =>
          analytics.sendEvent("click_email_link", {
            to: href,
          })
        }
        href={hrefStr}
        {...props}
      />
    );
  },
);
